import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import DevNewPassword from "../../../../../../presentation/pages/auth/developer/new-password";

import Authentication from "../../../../../../infra/cognito/authentication";
import { t } from "../../../../../../presentation/adapters/translate/translate";

const MakeDevNewPassword: React.FC = () => {
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState<string | null>("");

  const handleSubmit = async (values: any): Promise<void> => {
    try {
      await Authentication.newPasswordRequired(values["new-password"]);
      history.push("/");
    } catch (error: any) {
      setErrorMessage(t(error.code, error.message));
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    }
  };

  const dataForm = [
    {
      items: [
        {
          component: "InputPassword",
          type: "password",
          name: "new-password",
          title: "Nova Senha",
          label: "Nova Senha",
          placeholder: "Nova Senha",
          validations: "inputRequired",
        },
        {
          name: "button",
          component: "Button",
          title: "Enviar",
          submittingText: "Enviando...",
        },
      ],
    },
  ];

  const props = {
    onSubmit: handleSubmit,
    dataForm,
    errorMessage,
  };

  return <DevNewPassword {...props} />;
};

export default MakeDevNewPassword;
